'use client';
import { usePathname } from 'next/navigation';
import { createContext, useEffect, useState } from 'react';

type RouteHistory = {
  currentPath: string | null;
  previousPath: string | null;
};
export const RouteHistoryContext = createContext<RouteHistory>({
  currentPath: null,
  previousPath: null,
});

export function RouteHistoryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const [history, setHistory] = useState<RouteHistory>({
    currentPath: pathname,
    previousPath: null,
  });

  useEffect(() => {
    setHistory((prev) => {
      if (prev.currentPath === pathname) {
        return prev;
      }
      return {
        currentPath: pathname,
        previousPath: prev.currentPath,
      };
    });
  }, [pathname]);

  return (
    <RouteHistoryContext.Provider value={history}>
      {children}
    </RouteHistoryContext.Provider>
  );
}
